import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/sections/HeroSection';
import FeaturesSection from '../components/sections/FeaturesSection';
import CTASection from '../components/sections/CTASection';
import PricingPreview from '../components/sections/PricingPreview';
import { useTranslation } from '../hooks/useTranslation';
import { useSEO } from '../hooks/useSEO';

const ProxiesPage = () => {
  const { t } = useTranslation();
  useSEO('proxies'); 

  // Residential Data
  const residentialFeatures = t('proxies.residential.features.list', { returnObjects: true });
  const residentialList = Array.isArray(residentialFeatures) ? residentialFeatures : [];
  const residentialFeaturesWithIcons = residentialList.slice(0, 3).map((f, i) => ({
    ...f,
    icon: ['Globe', 'Shield', 'Zap'][i % 3]
  }));

  // Mobile Data
  const mobileFeatures = t('proxies.mobile.features.list', { returnObjects: true });
  const mobileList = Array.isArray(mobileFeatures) ? mobileFeatures : [];
  const mobileFeaturesWithIcons = mobileList.slice(0, 3).map((f, i) => ({
    ...f,
    icon: ['Smartphone', 'Zap', 'Lock'][i % 3]
  }));

  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main>
        <HeroSection 
          title1={t('proxies.main.hero.title1')}
          title2={t('proxies.main.hero.title2')}
          subtitle={t('proxies.main.hero.subtitle')}
          className="pb-12"
        />

        <PricingPreview />

        {/* Residential Section */}
        <div className="relative">
          <FeaturesSection 
            title={`${t('proxies.residential.hero.title1')} <span class="text-cyan-400">${t('proxies.residential.hero.title2')}</span>`}
            subtitle={t('proxies.residential.hero.subtitle')}
            features={residentialFeaturesWithIcons}
            columns={3}
            className="pb-40"
          />
          <div className="absolute bottom-12 w-full flex justify-center z-10">
            <Link to="/proxies/residential">
               <Button className="h-12 bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold px-8 py-3 rounded-md text-lg shadow-lg font-bold">
                 {t('common.learnMore') || 'Learn More'} <ArrowRight className="w-5 h-5 ml-2" />
               </Button>
            </Link>
          </div>
        </div>

        {/* Mobile Section */}
        <div className="relative bg-slate-900/50">
          <FeaturesSection 
            title={`${t('proxies.mobile.hero.title1')} <span class="text-cyan-400">${t('proxies.mobile.hero.title2')}</span>`}
            subtitle={t('proxies.mobile.hero.subtitle')}
            features={mobileFeaturesWithIcons}
            columns={3}
            className="pb-40"
          />
           <div className="absolute bottom-12 w-full flex justify-center z-10">
            <Link to="/proxies/mobile">
               <Button className="h-12 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white px-8 py-3 rounded-md text-lg shadow-lg font-bold">
                 {t('common.learnMore') || 'Learn More'} <ArrowRight className="w-5 h-5 ml-2" />
               </Button>
            </Link>
          </div>
        </div>

        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default ProxiesPage;